import React, { useEffect, useState } from "react";
import CustomModal from "../../../../Components/modals/CustomModal";
import { subscription } from "../../../../assets";
import { CiCircleCheck } from "react-icons/ci";
import {
  addSubscriptionApi,
  fetchSubscriptionPlanApi,
} from "../../../../services/groups";
import { toastMessage } from "../../../../utils/toastMessage";
import { LoadingButton } from "../../../../Components/header/form";
import Payment from "./Payment";

const SubscriptionPlan = ({ show, close, id, listing, setPage, setHasMore, type }) => {
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [plainDetails, setPlainDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const [subscriptionDetails, setSubscriptionDetails] = useState({});
  const [paymentModal, setPaymentModal] = useState(false);
  // console.log('id', id)
  //---------handle-Subscription-Plan-id------------
  const handleSubscriptionPlan = (data) => {
    setPlainDetails(data);
  };
  //--------subscription-plan-list-------------
  useEffect(() => {
    const fetchSubscriptionPlan = async () => {
      try {
        const { data } = await fetchSubscriptionPlanApi({ _group: id });
        const { success, message, data: response } = data;
        if (success) {
          setSubscriptionList(response || []);
        } else {
          toastMessage(message, "error", "getGroupDetail");
        }
      } catch (e) {
        console.log("Error:-", e.message);
      }
    };
    fetchSubscriptionPlan();
  }, [id]);
  //---------add-subscription------------------
  const addSubscription = async () => {
    if (!plainDetails?._id) {
      toastMessage("Please select a plan first.", "error", "planId");
      return;
    }
    try {
      setLoading(true);
      const { data } = await addSubscriptionApi({
        _subscriptionPrice: plainDetails?._id,
      });
      const { success, message, data: res } = data;
      if (success) {
        setSubscriptionDetails(res || {});
        close();
        setPaymentModal(true);
      }
      toastMessage(message, success ? "success" : "error", "addSubscription");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <CustomModal
        show={show}
        handleClose={close}
        className="subscription_model"
      >
        <div className="modal_subscription_wrap">
          <h3 className="subscription_title">Subscription</h3>

          <div className="months_plans_content">
            <div className="months_plans_container">
              {subscriptionList && subscriptionList.length > 0 ? (
                subscriptionList.map((data, ind) => (
                  <div
                    onClick={() => handleSubscriptionPlan(data)}
                    key={ind}
                    className={plainDetails?._id === data?._id ? "months_plans active" : 'months_plans'}
                  >
                    <div className="per_months">
                      <h6 className="per_plans">
                        {data?.currency || "currency N/A"}{" "}
                        {data?.price || "price N/A"}
                      </h6>
                      <p className="plans">
                        {data?.duration || "duration N/A"}{" "}
                        {data?.interval || "interval N/A"}
                      </p>
                    </div>
                    <img src={subscription} alt="Subscription_icon" />
                  </div>
                ))
              ) : (
                <div className="months_plans_container">
                  <h4>No Subscription Plan Found</h4>
                </div>
              )}
            </div>

            <b className="benefits">Subscription Benefits</b>

            <div className="benefit_detail">
              <ul>
                <li>
                  <span>
                    <CiCircleCheck className="circle_check" />
                  </span>
                  <p>View all group feeds and updates</p>
                </li>

                <li>
                  <span>
                    <CiCircleCheck className="circle_check" />
                  </span>
                  <p>Connect with other members through the member list.</p>
                </li>

                <li>
                  <span>
                    <CiCircleCheck className="circle_check" />
                  </span>
                  <p>Connect with other members through the member list.</p>
                </li>

                <li>
                  <span>
                    <CiCircleCheck className="circle_check" />
                  </span>
                  <p>Access additional group features and resources</p>
                </li>
              </ul>
            </div>
          </div>

          <div className="instruction_wraper">
            <b className="instraction_title">Instructions</b>

            <ul>
              <li>
                <p>Your subscription renews monthly until canceled.</p>
              </li>
              <li>
                <p>Cancel anytime from your account settings.</p>
              </li>
              <li>
                <p>
                  Once subscribed, you can immediately access all group content
                  and features.
                </p>
              </li>
            </ul>
          </div>
          <LoadingButton
            loading={loading}
            className="button subscribe_now"
            onClick={addSubscription}
          >
            Subscribe Now
          </LoadingButton>
        </div>
      </CustomModal>
      {/* ---------payment-modal----------------- */}
      <Payment
        {...{
          paymentModal,
          setPaymentModal,
          subscriptionDetails,
          plainDetails,
          listing, setPage, setHasMore, type
        }}
      />
    </>
  );
};

export default SubscriptionPlan;
